// extracted by mini-css-extract-plugin
export var sliderRange = "_ls-2";
export var sliderRoot = "_ls-0";
export var sliderThumb = "_ls-3";
export var sliderTrack = "_ls-1";